module.exports = __webpack_public_path__ + "static/media/sended_message_backdrop.28c062d4.svg";